// export const URL = "http://localhost:8000/"
// export const THIS_URL = "http://localhost:3000/"

// export const URL = "https://back.enterscience.com.br/"
// export const THIS_URL = "https://enterscience.com.br/"

// export const URL = "https://testeapi.enterscience.com.br/"
// export const THIS_URL = "https://teste.enterscience.com.br/"


export const URL = "https://igoob-back.dashboard.enterscience.com.br/"
export const THIS_URL = "https://igoob-landing.dashboard.enterscience.com.br/"

export const API_URL = URL + "api/";
export const STORAGE_URL = URL + "storage/";